import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { composeValidators, mustBeNumber } from 'components/helpers/validators';
import { useTranslation } from 'react-i18next';
import toast from 'shared/utils/toast';
import { IContractEquipment } from '../../types';
interface UpdateContractEquipmentDialogFormParams {
  contractEquipment: IContractEquipment;
  onSubmit: (id: any, values: any) => void;
}

function UpdateContractEquipmentDialog(params: UpdateContractEquipmentDialogFormParams) {
  const { t } = useTranslation();
  const { contractEquipment, onSubmit } = params;

  const onSubmitContractEquipment = async (values: any) => {
    if (
      (values.yearly_lease_amount && values.purchase_amount) ||
      (!values.yearly_lease_amount && !values.purchase_amount)
    ) {
      toast.warning(
        t('pages.contract-equipment.edit.only_one_allowed', {
          field1: t('entities.contract-equipment.yearly_lease_amount'),
          field2: t('entities.contract-equipment.purchase_amount')
        })
      );
      return;
    }

    const params = {
      yearly_lease_amount: values.yearly_lease_amount
        ? String(values.yearly_lease_amount).replace(',', '.')
        : null,
      yearly_maintenance_amount: values.yearly_maintenance_amount
        ? String(values.yearly_maintenance_amount).replace(',', '.')
        : null,
      purchase_amount: values.purchase_amount
        ? String(values.purchase_amount).replace(',', '.')
        : null
    };

    onSubmit(contractEquipment.id, params);
  };

  return (
    <div className="flex flex-col gap-3">
      <EnhancedForm
        onSubmit={onSubmitContractEquipment}
        formId="updateContracEquipment"
        hideControls>
        <div className="flex flex-wrap">
          <div className="w-full md:w-1/3 mb-2 pr-0 md:pr-4">
            <IdentityField
              name="yearly_lease_amount"
              component={TextFieldAdapter}
              label={t('entities.contract-equipment.yearly_lease_amount')}
              type="number"
              validate={composeValidators(mustBeNumber)}
              defaultValue={parseInt(contractEquipment.yearly_lease_amount as any) || null}
            />
          </div>
          <div className="w-full md:w-1/3 mb-2 pr-0 md:pr-4">
            <IdentityField
              name="yearly_maintenance_amount"
              component={TextFieldAdapter}
              label={t('entities.contract-equipment.yearly_maintenance_amount')}
              type="number"
              validate={composeValidators(mustBeNumber)}
              defaultValue={parseInt(contractEquipment.yearly_maintenance_amount as any) || null}
            />
          </div>
          <div className="w-full md:w-1/3 mb-2">
            <IdentityField
              name="purchase_amount"
              component={TextFieldAdapter}
              label={t('entities.contract-equipment.purchase_amount')}
              type="number"
              validate={composeValidators(mustBeNumber)}
              defaultValue={parseInt(contractEquipment.purchase_amount as any) || null}
            />
          </div>
        </div>
      </EnhancedForm>
    </div>
  );
}

export default UpdateContractEquipmentDialog;
